"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventSchema = void 0;
function createEventSchema(type, subType, metadataSchema) {
    return {
        type: 'object',
        properties: {
            type: { type: 'string', const: type },
            subType: { type: 'string', const: subType },
            key: { type: 'string' },
            timestamp: { type: 'number', minimum: 0 },
            metadata: metadataSchema
        },
        required: ['type', 'subType', 'key', 'timestamp', 'metadata'],
        additionalProperties: false
    };
}
exports.createEventSchema = createEventSchema;
//# sourceMappingURL=utils.js.map